var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.414062,
    y: 0.09375,
    width: 21.2131,
    height: 21.2131,
    rx: 10.6066,
    fill: "#60EC2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4991_29698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95703 6.27474C5.95703 5.84681 6.31263 5.5 6.75138 5.5H15.9793C16.418 5.5 16.7736 5.84681 16.7736 6.27474V15.5419C16.7736 15.9698 16.418 16.3166 15.9793 16.3166H6.75138C6.31263 16.3166 5.95703 15.9698 5.95703 15.5419V6.27474ZM9.29869 14.5549V9.67048H7.67552V14.5549H9.29869ZM8.48744 9.00323C9.05329 9.00323 9.4055 8.6287 9.4055 8.15953C9.39536 7.68022 9.05396 7.31584 8.49826 7.31584C7.94256 7.31584 7.57952 7.6809 7.57952 8.15953C7.57952 8.6287 7.93174 9.00323 8.47663 9.00323H8.48744ZM11.8054 14.5549V11.827C11.8054 11.681 11.8163 11.535 11.8595 11.4309C11.9765 11.1395 12.2435 10.8373 12.6924 10.8373C13.2799 10.8373 13.5145 11.2849 13.5145 11.942V14.5549H15.1376V11.7534C15.1376 10.2525 14.3372 9.55488 13.2691 9.55488C12.4078 9.55488 12.0218 10.0281 11.8054 10.3614V10.3783H11.7946L11.8054 10.3614V9.67048H10.1829C10.2032 10.1288 10.1829 14.5549 10.1829 14.5549H11.8054Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4991_29698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8166,
    height: 10.8166,
    fill: "white",
    transform: "translate(5.95703 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d775b4bc600736fd995f958ac85e3c5c.svg";
export { ForwardRef as ReactComponent };